import {combineReducers} from 'redux'

import {userReducer} from "../../screens/user/reducers/userReducer";
import {memberReducer} from "../../screens/members/reducers/seniorsReducer";
import {relativesReducer} from "../../screens/members/reducers/relativesReducer";
import {timelineReducer} from "../../screens/timeline/reducers/timelineReducer";
import {hasMoreReducer} from "../../screens/timeline/reducers/hasMoreReducer";
import {imageReducer} from "../../screens/image/reducers/imageReducer";
import {twilioReducer} from "../modules/twilio/reducers/twilioReducer";
import {rocketChatReducer} from "../modules/rocketChat/reducers/rocketChatReducer";
import {videoReducer} from "../../screens/video/reducers/videoReducer";
import {messageReducer} from "../../screens/message/reducers/messageReducer";
import {notificationReducer} from "../modules/notification/reducers/notificationReducer";
import { pushReducer } from '../modules/notification/reducers/pushReducer';

export default {
  user: userReducer,
  seniors: memberReducer,
  relatives: relativesReducer,
  timeline: combineReducers({items: timelineReducer, hasMore: hasMoreReducer}),
  image: imageReducer,
  video: videoReducer,
  message: messageReducer,
  // Shared
  twilio: twilioReducer,
  rocketChat: rocketChatReducer,
  notifications: notificationReducer,
  push: pushReducer
};
